import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "js-auto-fix-dialog",
    class: "dialog p-topPreview",
    style: { "z-index": "500", "display": "block" }
};
const _hoisted_2 = { class: "p-topPreview__inner" };
const _hoisted_3 = { style: { "display": "flex", "align-items": "center", "justify-content": "space-around" } };
const _hoisted_4 = { class: "p-topPreview__title" };
const _hoisted_5 = { id: "js-fix-result-number" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", { style: { "color": "red", "font-weight": "bold" } }, "修正前に内容の確認をしてください", -1);
const _hoisted_7 = /*#__PURE__*/ _createStaticVNode("<div class=\"p-topPreviewContents\"><div class=\"p-topPreviewContents__left\"><h3 class=\"p-topPreview__subtitle\">修正前</h3><div><pre id=\"js-before-auto-fix\"></pre></div></div><div class=\"p-topPreviewContents__right\"><h3 class=\"p-topPreview__subtitle--blue\">修正後</h3><div><pre id=\"js-after-auto-fix\"></pre></div></div></div>", 1);
const _hoisted_8 = { class: "p-topPreview__btns" };
import axios from 'axios';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FixPreviewModal',
    props: {
        fixStatus: {},
        saveUserFixHistoryUrl: {},
        ruleConfigs: {},
        closeModal: { type: Function }
    },
    emits: ['update', 'execLint', 'resetFixCounter'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const fixedApply = async () => {
            const afterText = document.getElementById('js-after-auto-fix');
            const beforeText = document.getElementById('text');
            if (!afterText || !beforeText)
                return;
            if (!confirm('修正を適用しますか？'))
                return;
            const fixedText = afterText.textContent ?? '';
            await axios.post(props.saveUserFixHistoryUrl, {
                rules: props.fixStatus.fixedResult,
                fixedText: fixedText,
                keyMap: props.ruleConfigs.ruleKeyToIdMap,
                beforeText: beforeText.innerText
            });
            const formmated = fixedText
                .replace(/\r\n/g, '\n')
                .replace(/\r/g, '\n')
                .split('\n')
                .map((line) => {
                if (line === '')
                    return '<div><br></div>';
                return '<div>' +
                    line
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;')
                        .replace(/ /g, '&nbsp;')
                        .replace(/　/g, '&#x3000;')
                    + '</div>';
            })
                .join('');
            emit('update', formmated);
            props.closeModal();
            // 修正適用時、文字数制限を超えるケースがあるため自動修正時は文字数制限のチェックをスキップして再度校正を実行する
            emit('execLint', { skipMaxLengthCheck: true });
            emit('resetFixCounter');
        };
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h2", _hoisted_4, [
                            _createTextVNode("自動修正のプレビュー"),
                            _createElementVNode("span", _hoisted_5, "修正件数:" + _toDisplayString(_ctx.fixStatus.fixedRuleLength), 1)
                        ]),
                        _hoisted_6
                    ]),
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                            type: "button",
                            id: "js-cancel-fix",
                            class: "p-topPreview__btn u-mgRight--20",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                        }, "キャンセル"),
                        _createElementVNode("button", {
                            type: "button",
                            id: "js-apply-fix",
                            class: "p-topPreview__submit",
                            onClick: fixedApply
                        }, "修正する")
                    ])
                ])
            ], 512)), [
                [_vShow, _ctx.fixStatus.isFixPreviewOpen]
            ]);
        };
    }
});
